import { useQuery } from '@tanstack/react-query';
import { useDtcCommerceMmmData } from '../context/DtcCommerceMmmDataContext';
import { DashboardData } from '../dtc-commerce-mmm-types';
import { loadMarketData } from '../utils/dtc-commerce-mmm-markets-loader';

// Each market's rows for the loaded run, on surfaces whose config sets showMarkets. Starts once
// the national data is in, and runs on its own so the rest of the page never waits on it.
export const useMarketData = (data: DashboardData) => {
  const { config, runContext } = useDtcCommerceMmmData();
  return useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['mmmMarketData', runContext],
    queryFn: () => {
      if (!runContext) throw new Error('No run selected');
      return loadMarketData(runContext, data);
    },
    enabled: Boolean(config.showMarkets && runContext),
    staleTime: Infinity,
    // The market file falls back to Comet on its own; a retry would only repeat a large download.
    retry: false
  });
};
